import 'ulog';
import App from './App.svelte';
import './css/main.css';

window.CompassApp = (opts) => {
  return new App(opts);
};
